import React from "react";
import styles from "./MapComponent.module.css";

export default function MapControls({ showFullRoute, onToggleRoute }) {
  return (
    <div className={styles.mapButtons}>
      <button
        className={`${styles.mapButton} ${
          showFullRoute ? styles.mapButtonActive : ""
        }`}
        onClick={onToggleRoute}
      >
        {showFullRoute ? "Скрыть маршрут" : "Показать маршрут"}
      </button>
    </div>
  );
}
